import backgroundImage from "../../../assets/du-an-chung-toi.png";
import ProjectCard from "../../../components/pages/ProjectCard/ProjectCard";
import { useProjects } from "../../../hooks/pages/projects/useProjects";

const ProjectsPage = () => {
  const { projects, loading } = useProjects();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-[60vh]">
        <p className="text-gray-500 text-lg animate-pulse">
          Đang tải dự án...
        </p>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <section
        className="relative flex flex-col justify-center items-center text-center py-20 md:py-28 overflow-hidden"
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      >
        <div className="absolute inset-0 bg-black/40" />

        <div className="relative z-10 max-w-7xl px-4">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4 font-serif text-white">
            DỰ ÁN CHÚNG TÔI
          </h1>

          <p className="text-lg md:text-xl text-white max-w-2xl mx-auto">
            Cập nhật thông tin mới nhất các dự án bất động sản.
          </p>
        </div>
      </section>

      {!projects.length ? (
        <p className="text-center text-gray-500 py-20">
          Chưa có dự án nào.
        </p>
      ) : (
        <div className="max-w-7xl mx-auto px-4 py-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project, index) => (
            <ProjectCard
              key={project.id}
              project={project}
              index={index}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ProjectsPage;